/** Bump when legal text changes so users must re-accept. */
export const TTS_AUDIO_TERMS_VERSION = '1.0';

export function getTtsAudioTerms(): string {
    return $localize`StoryHunt Audio Generation Terms

These terms apply when you use StoryHunt Creator to generate audio (text-to-speech) for stories and tours.

1. Ownership of generated audio
1.1 All audio files generated through StoryHunt's text-to-speech feature ("Generated Audio") are and remain the exclusive property of StoryHunt ApS ("StoryHunt").
1.2 You do not acquire ownership of Generated Audio by creating, downloading, previewing, or publishing it.

2. Permitted use
2.1 You may use Generated Audio only within the StoryHunt Platform (including StoryHunt Creator, StoryHunt website, StoryHunt web app, and StoryHunt App) as part of StoryHunt experiences you manage.
2.2 You may not use, copy, distribute, sell, license, publicly perform, or otherwise exploit Generated Audio outside the StoryHunt Platform.
2.3 You may not extract, download for external use, re-host, or transfer Generated Audio to any third-party system, website, app, device, or distribution channel unless StoryHunt has given prior written consent.

3. Your content
3.1 You remain responsible for the story text and other content you submit for audio generation.
3.2 You confirm that you have the rights needed to submit that content for generation and use on the StoryHunt Platform.

4. Account and authority
4.1 By accepting these terms, you confirm that you are authorized to bind the account, organization, or company under which you generate audio.
4.2 Acceptance is recorded with your user identity, username, email, and timestamp, and applies to future audio generation under that account.

5. Breach
5.1 Unauthorized use of Generated Audio outside the StoryHunt Platform is a material breach and may result in suspension or termination of access, and StoryHunt may pursue available legal remedies.

6. Governing law
6.1 These terms are governed by Danish law. The City Court of Copenhagen has jurisdiction in the first instance, unless mandatory law provides otherwise.

Version: ${TTS_AUDIO_TERMS_VERSION}`;
}
